import Service from '@/services/abstract/service'
import Functions from '@/utils/functions'

export default class Campanhas extends Service {

  constructor() {
    super()

    this._campanhasCollection = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Campanhas`
    )
  }

  async create(data) {
    data.ativo = true
    data.dataCriacao = new Date()

    try {
      this._campanhasCollection.doc().set(data)
      return Promise.resolve('Campanha inserida com sucesso')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async update(id, data) {
    data.dataAlteracao = new Date()

    try {
      this._campanhasCollection.doc(id).update(data)
      return Promise.resolve('Campanha alterada com sucesso')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async list(ativo = true) {
    let campanhas = new Array()

    try {
      const resultCampanhas = await this._campanhasCollection.where('ativo', '==', ativo).get()
      if (!resultCampanhas.empty) {
        for (let doc of resultCampanhas.docs) {
          campanhas.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
    } catch (error) {
      return Promise.reject(error)
    }

    return Promise.resolve(campanhas)
  }

  async getByEmpresa(empresas, ativo = true) {
    let campanhas = new Array()
    const groupsEmpresas = Functions.dividirArray(empresas, 10)

    try {
      if (Array.isArray(empresas)) {
        for (const group of groupsEmpresas) {
          let campanhasQuerySnap = await this._campanhasCollection
            .where('empresas', 'array-contains-any', group)
            .where('ativo', '==', ativo)
            .get()
          if (!campanhasQuerySnap.empty) {
            for (let campanha of campanhasQuerySnap.docs) {
              campanhas.push({
                id: campanha.id,
                ...campanha.data()
              })
            }
          }
        }
      } else {
        let campanhasQuerySnap = await this._campanhasCollection
          .where('empresas', 'array-contains-any', [empresas])
          .where('ativo', '==', ativo)
          .get()
        if (!campanhasQuerySnap.empty) {
          for (let campanha of campanhasQuerySnap.docs) {
            campanhas.push({
              id: campanha.id,
              ...campanha.data()
            })
          }
        }
      }

      return Promise.resolve(campanhas)
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }
}
